import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { PatientUploadExamsService } from '../../services/exams/patient-upload-exams.service'

@Component({
	selector: 'app-upload-file-patient',
	templateUrl: './upload-file-patient.component.html',
	styleUrls: ['./upload-file-patient.component.scss'],
})
export class UploadFilePatientComponent implements OnInit {
	uuid: string = ''
	loading: boolean = false
	selectedFile: File | null = null
	uploadedFiles: string[] = []

	private appointmentId: string = ''
	private patientId: string = ''

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private patientUploadExamsService: PatientUploadExamsService
	) {
		this.route.params.subscribe((params) => {
			this.uuid = params['uuid']
		})
		this.getConfig()
	}

	ngOnInit(): void {}

	getConfig() {
		if (this.uuid) {
			this.appointmentId = this.uuid.split('--')[0]
			this.patientId = this.uuid.split('--')[1]
			console.log(this.appointmentId, this.patientId)
		}
	}

	sendFile(file: File) {
		const self = this
		if (self.appointmentId && self.patientId) {
			self.loading = true
			self.patientUploadExamsService.uploadExamsPatient(
				{
					patientId: self.patientId,
					appointmentId: self.appointmentId,
					file,
				},
				{
					fnSuccess() {
						self.uploadedFiles.push(file.name)
						self.selectedFile = null
					},
					fnError() {},
					fnFinalized() {
						self.loading = false
					},
				}
			)
		}
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement
		if (input.files && input.files.length > 0) {
			this.selectedFile = input.files[0]
		}
	}

	onUpload(): void {
		if (this.selectedFile) {
			this.sendFile(this.selectedFile)
		}
	}
}
